import { Person } from '@/models/Person';

export enum ImportStatus {
    COMPLETED = 'COMPLETED',
    COMPLETED_WITH_ERRORS = 'COMPLETED_WITH_ERRORS',
    STARTED = 'STARTED',
    NOT_STARTED = 'NOT_STARTED',
}

export interface EnrollmentProcess {
    id: number;
    programClassId: number;
    filename: string;
    applicationId: number;
    organizationId: number;
    personId: number;
    itemsCount: number;
    successItemsCount: number;
    errorItemsCount: number;
    startDate: Date;
    finishDate: Date;
    status: ImportStatus;
    multipleClassEnrollmentMode: boolean;
    enrollmentProcessItems: EnrollmentProcessItem[];
    person: Person;
}

export interface EnrollmentProcessItem {
    id: number;
    enrollmentProcessId: number;
    importData: string;
    message: string;
    startDate: Date;
    finishDate: Date;
    status: ImportStatus;
    person?: Person;
    statusCode: string;
}
